import { configureStore } from "@reduxjs/toolkit";
import modalSlice from "./modal.slice";
import meSlice from "./me.slice";
import topicsSlice from "./topics.slice";

export default configureStore({
  reducer: {
    modal: modalSlice,
    me: meSlice,
    topics: topicsSlice,
  },
});
